import { eff } from "@/core/utils/effect-ts-abbr";
import { computed, shallowRef } from "vue";
import { AuthenticatedVehicleTileDto } from "../api-contract/api-contract";

class ComparisonModel {
    selectedItems = shallowRef<ReadonlyMap<number, boolean>>(new Map());

    isOnlySpecialDealsSelected = computed(() =>
        eff.fn.pipe(
            this.selectedItems.value,
            eff.map.filterWithIndex((_key, value) => !value),
            eff.map.isEmpty,
        ),
    );

    toggleComparison = (
        vehicleId: number,
        isSpecialVehicle: boolean,
        forceValue = !this.selectedItems.value.has(vehicleId),
    ) => {
        if (forceValue === this.selectedItems.value.has(vehicleId)) {
            return;
        }

        if (forceValue) {
            this.selectedItems.value = eff.fn.pipe(
                this.selectedItems.value,
                eff.map.insert(vehicleId, isSpecialVehicle),
            );
        } else {
            this.selectedItems.value = eff.fn.pipe(
                this.selectedItems.value,
                eff.map.remove(vehicleId),
            );
        }
    };

    /**
     * Remove selected items except visible ones.
     */
    reset = (visibleVehicles: readonly AuthenticatedVehicleTileDto[]) => {
        const visibleVehicleIds = eff.fn.pipe(
            visibleVehicles,
            eff.array.map(({ id }) => id),
        );

        this.selectedItems.value = eff.fn.pipe(
            this.selectedItems.value,
            eff.map.filterWithIndex((id, _value) => visibleVehicleIds.includes(id)),
        );
    };
}

export const comparisonModel = new ComparisonModel();
